module.exports = __webpack_public_path__ + "static/media/unisq-logo.9c6ae5a2.svg";